import { create } from 'zustand';
import { getSession } from './auth';

const load = (k, d) => { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } };
const save = (k, v) => localStorage.setItem(k, JSON.stringify(v));

/* The OVERARCHING account key. Every Vectorize namespace + D1 row is scoped
   to this so learned context is shared across ALL the account's projects. */
export const accountId = () =>
    (getSession()?.email || 'local-anon').toLowerCase().replace(/[^a-z0-9]+/g, '_');

export const useScrapeStore = create((set, get) => ({
    /* Cloudflare learning Worker + local Ollama gateway config */
    workerBase: load('roocad_worker_base', ''),          // https://<worker>.workers.dev
    ollamaBase: load('roocad_ollama_base', 'http://localhost:11434'),
    embedModel: load('roocad_embed_model', 'nomic-embed-text'),
    connected: false,
    testing: false,

    /* Settings → AI Training state */
    training: {
        running: false,
        urls: load('roocad_training_urls', []),
        message: '',
        error: '',
    },

    /* Amplified knowledge pulled from Vectorize for the AI Command Bar */
    amplified: { context: '', matches: [] },

    /* Performance/LOD telemetry for the 60 FPS budget */
    perf: { fps: 60, dropped: 0, quality: 'high' }, // 'high' | 'mid' | 'low'

    setWorkerBase: (base) => { save('roocad_worker_base', base); set({ workerBase: base }); },
    setOllamaBase: (base) => { save('roocad_ollama_base', base); set({ ollamaBase: base }); },
    setEmbedModel: (m) => { save('roocad_embed_model', m); set({ embedModel: m }); },
    setConnected: (v) => set({ connected: v }),
    setTesting: (v) => set({ testing: v }),
    setTraining: (partial) => set((s) => ({ training: { ...s.training, ...partial } })),
    pushUrl: (url) => {
        const urls = [...get().training.urls, { url, at: Date.now() }];
        save('roocad_training_urls', urls);
        set({ training: { ...get().training, urls } });
    },
    setAmplified: (a) => set({ amplified: a }),
    setFps: (fps) => set({ perf: { ...get().perf, fps } }),
    setDropped: (dropped) => set({ perf: { ...get().perf, dropped } }),
    setQuality: (quality) => set({ perf: { ...get().perf, quality } }),
}));